export default "__VITE_ASSET__8dbfe9af__"